import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '@/config/firebase';
import { collaboratorAllocationsQueryKeys } from './useCollaboratorAllocationsQuery';

export interface DeleteCollaboratorAllocationVariables {
  collaboratorId: string;
  allocationId: string;
}

export function useDeleteCollaboratorAllocationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ collaboratorId, allocationId }: DeleteCollaboratorAllocationVariables) => {
      if (!collaboratorId) {
        throw new Error('Colaborador não informado.');
      }

      if (!allocationId) {
        throw new Error('Alocação não informada.');
      }

      const allocationRef = doc(
        db,
        'collaborators_private',
        collaboratorId,
        'allocations',
        allocationId
      );

      await deleteDoc(allocationRef);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: collaboratorAllocationsQueryKeys.list(variables.collaboratorId),
      });
    },
  });
}

export type UseDeleteCollaboratorAllocationMutationResult = ReturnType<
  typeof useDeleteCollaboratorAllocationMutation
>;
